import { useCallback, useEffect, useState } from "react";
import type { ProductListItem } from "../../../shared/types";
import { api, ApiError } from "../../lib/api";
import { useOnShown } from "../../lib/inApp";

// Why: on an iPad the list stays beside each product it opens; keeping the last answer draws it at once.
let last: ProductListItem[] | null = null;

/** Load the products ahead of a tap on their tab, unless they are already here. */
export function warmProducts(): void {
  if (!last) api.products.list().then((d) => (last = d.products), () => {});
}

/**
 * Every product in the account, read afresh on arrival and when the phone app shows the screen again, and shown
 * from the last answer meanwhile.
 */
export function useProducts(): { items: ProductListItem[] | null; err: string | null } {
  const [items, setItems] = useState<ProductListItem[] | null>(last);
  const [err, setErr] = useState<string | null>(null);
  const read = useCallback((alive: () => boolean) => {
    api.products
      .list()
      .then((d) => {
        last = d.products;
        if (alive()) setItems(d.products);
      })
      .catch((e: unknown) => alive() && setErr(e instanceof ApiError ? e.message : String(e)));
  }, []);
  useEffect(() => {
    let alive = true;
    read(() => alive);
    return () => {
      alive = false;
    };
  }, [read]);
  useOnShown(() => read(() => true));
  return { items, err };
}
